exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".top-notification-bar{color:#fff;padding:3px}.top-notification-bar .notification-title{font-weight:700}.top-notification-bar span{margin:0 0 0 20px}.top-notification-bar .notification-close{margin:0 20px 0 0;font-weight:700;float:right}.top-notification-bar h4{font-size:.9rem}.top-notification-bar *{display:inline;color:#fff}.top-notification-bar-error{background-color:#a30000}.top-notification-bar-info{background-color:#3576c6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/TopNotificationBar/index.scss
// module id = 1025
// module chunks = 0